import React from 'react';

import {message} from 'antd';
import {observable} from "mobx";
import {http, addVisitLog, history} from 'libs';
import gStore from 'store';

class Store {
  @observable records = [];
  @observable orderId = '';
  @observable file = {};
  @observable isFetching = false;
  @observable showCartTooltip = false;
  @observable addCartLoading = false;
  @observable selectedRowKeys = []
  @observable selectedCustomKeys = []
  @observable userAddRecords = []
  @observable hide = null
  @observable record = {
    brand: ""
    , created_at: ""
    , customerId: 0
    , deliveryDate: null
    , desc: ""
    , extraSn: null
    , factoryCode: ""
    , formats: ""
    , id: ''
    , isMeasure: false
    , name: ""
    , number: 1
    , productId: null
    , catalog: "Sale"
    , isEdit: true
  }

  //还有个获取的， GET ， 返回的 {default: [], custom: []} 这样的数据结构
  fetchRecords = () => {
    this.records.length === 0 && (this.isFetching = true)
    return http.get('/javaApi/front/cart/listAll')
      .then(res => {
        // this.records = res.data.result
        this.records = res.data.result['default']
        gStore.shoppingTotal = this.records.length
        // this.userAddRecords = res.data.result['custom']
        // this.userAddRecords.map(v => v['isEdit'] = false)
      })
      .finally(() => this.isFetching = false)
  };

  //加入购车 （商品列表、详情 ）
  addRecord = (id, catalog, number = 1) => {
    this.addCartLoading = true;
    const params = {productId: id, catalog: catalog, number: number};
    addVisitLog({
      pageName: "加入购物车",
      fromPageUrl: window.referrerUrl,
      pageUrl:`${window.location.origin}${history.location.pathname}`,
      eventCode: "AddCart",
      eventName: "加入购物车",
      content: JSON.stringify(params)
    })
    const key = 'updateCart';
    message.loading({content: 'Loading...', key})
    return http.post('/javaApi/front/cart/edit', params)
      .then(() => {
        this.addCartLoading = false;
        this.fetchRecords();
        message.success({content: '已加入购物车',key,duration:0.1})
      })
      .catch(v => {
        this.addCartLoading = false;
        message.error({content: v || '加入购物车失败',key,duration:1})
      })
  }

  authFileUrl = (params)=>{
    return http.post('/javaApi/oss/authFileUrl',params);
  }

  getFile = (params)=>{
    return http.post('/javaApi/oss/getFileUrl',params);
  }


  deleteFile = (params)=>{
    return http.post('/javaApi/oss/delFile',params);
  }

  // 更新数量和项目编号
  updateRecord = (index, record, val, name) => {
    const key = 'updateCart';
    message.loading({content: 'Loading...', key});
    let data = {
      id: record.id,
      number: record.number,
      cartRemarks: record.cartRemarks,
      isMeasure: record.isMeasure,
    };
    if (name==='number') {
      data.number = val;
    }else if(name==='isMeasure'){
      data.isMeasure = val?1:0;
    }else if (name ==='cartRemarks'){
      if (val.length>50) {
        return message.error({content: '购物车备注不能超过50个字!', key, duration: 1})
      }
      data.cartRemarks = val;
    }
    return http.post('/javaApi/front/cart/edit', data)
      .then(() => {
        // this.records[index][name] = val
        this.fetchRecords();
        message.success({content: '修改成功!', key, duration: 1});
      })
  }

  // 添加、更新用户自己添加的商品
  updateUserAddRecord = (data, index = 0) => {
    this.userAddRecords[index] = data
    // const key = 'userAddCart';
    // message.loading({content: 'Loading...', key});

  //  return http.post('/javaApi/front/cart/edit', data)
  //     .then(() => {
  //       // this.userAddRecords[index] = data
  //       // this.userAddRecords[index]['isEdit'] = false
  //       this.fetchRecords()
  //       message.success({content: '修改成功!', key, duration: 1});
  //     })
  }

  //删除
  delRecord = (id, index = -1, type = 0) => {
    const key = 'deleteCart';
    message.loading({content: 'Loading...', key});
    http.post('/javaApi/front/cart/delete',{id:id})
      .then(() => {
        // if (type) {
        //   this.userAddRecords.splice(index, 1)
        // } else if (index !== -1) {
        //   this.records.splice(index, 1)
        // }
        this.fetchRecords()
        message.success({content: '已删除!', key, duration: 2});
      })
  }

    //删除所有购物车
    delRecordAll = () => {
      const key = 'deleteCart';
      message.loading({content: 'Loading...', key});
      http.post('/javaApi/front/cart/deleteAll')
        .then(() => {
          this.fetchRecords()
          this.userAddRecords = [];
          message.success({content: '已删除!', key, duration: 2});
        })
    }

  //提交求购
  postInquiry = () => {
    return http.post('/javaApi/front/cart/createInquiry', {ids: this.selectedRowKeys,inquiryItems:this.userAddRecords,attachmentPath:this.file.filePath,attachmentName:this.file.fileName})
      .then(res => {
        this.selectedRowKeys=[]
        this.selectedCustomKeys=[]
        this.orderId = res.data.result
        message.success('提交求购成功')
        this.userAddRecords = [];
        this.fetchRecords()
      })
  }


}

export default new Store()

// brand: "鱼跃"
// brand_code: "QLC"
// created_at: "2020-10-22 12:29:41"
// desc: null
// details: "<p></p><div class="media-wrap image-wrap"><img src="http://public-buket.oss-cn-hangzhou.aliyuncs.com/clinical/2010/ad68f1bb6bef40ee922d7f8ef8d42c92.png"/></div><p></p>"
// factory_code: "YHT-101"
// formats: "套"
// id: 23
// is_hot: false
// lease_able: false
// lease_price: 0
// main_images: [,…]
// material_code: "QLC*YHT-101*SXH5"
// name: "耳温枪"
// sale_able: true
// sale_price: 635
// status: "1"
// stock_number: 0
// supplier_code: "SXH5"
// thumb: "http://public-buket.oss-cn-hangzhou.aliyuncs.com/clinical/2010/5681d2a7a367484c8e09a00ccf60ec4d.png"
// number: 1
// product_id: "23"
// type: 1
